var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.81 38.8075 50 25 50C11.1925 50 0 38.81 0 25C0 11.195 11.1925 0 25 0C38.8075 0 50 11.195 50 25Z",
    fill: "#24C277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0309 33.1202C21.4709 33.1202 20.9109 32.9077 20.4834 32.4802L14.5509 26.5477C13.6959 25.6927 13.6959 24.3077 14.5509 23.4552C15.4059 22.6002 16.7884 22.5977 17.6434 23.4527L22.0309 27.8402L32.3509 17.5202C33.2059 16.6652 34.5884 16.6652 35.4434 17.5202C36.2984 18.3752 36.2984 19.7602 35.4434 20.6152L23.5784 32.4802C23.1509 32.9077 22.5909 33.1202 22.0309 33.1202Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessCheck);
export default __webpack_public_path__ + "static/media/icon-success-check.6825518f.svg";
export { ForwardRef as ReactComponent };